import $ from 'jquery';

const defaults = {
  wrapper: '.type-select',
  trim: false,
  onChange: false,
  option: 0,
};

function SelectFix(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.wrapper = this.settings.wrapper;
  this.trim = this.settings.trim;
  this.onChange = this.settings.onChange;
  this.label = this.getLabel();
  this.id = this.getListID();
  this.init();
  this.ready();
}

SelectFix.prototype = {
  init() {
    this.$element.find(`#${this.id} option`).eq(0).text(this.label);

    if (this.onChange) {
      this.$element.find(`#${this.id}`).attr('onChange', 'this.form.submit()');
      this.$element.find('.form-actions').hide();
    }
  },

  trimLabel(l) {
    let label = l;
    if (label.length) {
      label = (this.trim) ? label.substring(0, label.indexOf(':')) : label;
      return label;
    }
    return null;
  },

  getLabel() {
    return this.trimLabel(this.$element.find(`${this.wrapper} label`).text());
  },

  getListID() {
    return this.$element.find(`${this.wrapper} select`).attr('id');
  },

  ready() {
    this.$element.addClass('ready');
  },
};

export default SelectFix;



// WEBPACK FOOTER //
// ./SelectFix.js